import React from "react";
import "../styles/Home.css";
import { Carousel } from "react-bootstrap";
import food from "../assets/food2.jpg";
import storyImg from "../assets/food3.jpg"; // your uploaded image
import storyImg1 from "../assets/f3.jpg";
import storyImg2 from "../assets/f4.jpg";
export default function Home() {
  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
  };

  const images = [storyImg, storyImg1, storyImg2];
  return (
    <div className="main-div">
      {/* First Section */}
      <section className="intro-wrapper">
        <div className="intro-container">
          <h1 className="intro-title">
            Alfa SouthIn Cafe: Our Digital <br />
            Presence Strategy
          </h1>
          <p className="intro-description">
            Welcome to <strong>Alfa SouthIn Cafe</strong>, a cozy culinary
            escape in the heart of Pune, where tradition meets taste. We
            specialize in authentic <strong>South Indian delicacies</strong>{" "}
            paired with comforting café classics served fresh, fast, and full of
            flavor.
          </p>
        </div>
        <div className="intro-image">
          <img src={food} alt="South Indian Food" className="f1" />
        </div>
      </section>

      {/* ✅ Second Section */}
      <section className="cuisine-section">
        <div className="cuisine-container">
          <h2 className="intro-title1">
            Our Unique South Indian Cuisine Experience
          </h2>
          <div className="cuisine-text">
            {/* <h4 style={{ fontSize: "23px", color: "#39512f" }}>Key Elements</h4> */}

            <div className="cuisine-box">
              <div className="left-border" />
              <div className="content">
                <h5
                  className="text1"
                  style={{ fontSize: "19px", color: "#3e3a35" }}
                >
                  Why Us
                </h5>
                <p
                  className="text1"
                  style={{ fontSize: "16px", color: "#3e3a35" }}
                >
                  Alfa Southin Cafe, we serve more than just food; we serve
                  tradition, warmth, and comfort. Our dishes are crafted with
                  authentic South Indian flavors, using fresh ingredients and
                  time-tested recipes. Whether you're here for a hearty meal or
                  a quick coffee break, we offer a cozy space, friendly service,
                  and a taste that feels like home.
                </p>
              </div>
            </div>

            <div className="cuisine-box">
              <div className="left-border" />
              <div className="content">
                <h5
                  className="text1"
                  style={{ fontSize: "19px", color: "#3e3a35" }}
                >
                  About Us
                </h5>
                <p
                  className="text1"
                  style={{ fontSize: "16px", color: "#3e3a35" }}
                >
                  At Alfa Southin Cafe, we serve the soul of South India right
                  here in Pune. From crispy dosas to aromatic filter coffee,
                  every dish is freshly prepared with authentic flavors and
                  heartfelt care. Whether you're grabbing a quick bite or
                  unwinding over a chai, Alfa Southin Cafe is your cozy spot for
                  comfort food and warm vibes.
                </p>
              </div>
            </div>

            <div className="cuisine-box">
              <div className="left-border" />
              <div className="content">
                <h5
                  className="text1"
                  style={{ fontSize: "19px", color: "#3e3a35" }}
                >
                  Our Special Menus
                </h5>
                <p
                  className="text1"
                  style={{ fontSize: "16px", color: "#3e3a35" }}
                >
                  Beverages, Break Fast, Snacks, Egg Dishes, Vegetables, Roti,
                  Thali, Punjabi Dishes, Rice, Al-Faham Special, Indian Cuisine,
                  Tandoori Starter, Friday Special, Paneer Dish, Chinese Veg
                  Rice, Chinese Veg Noodles, Chinese Non-Veg Rice, Chinese
                  Non-Veg Noodles, Veg Starter Chinese, Veg Soup, Chicken
                  Starter Chinese, Non-Veg Soup, Shawarma Special, Chicken
                  Dishes, Chicken Kheema.
                </p>
              </div>
            </div>
          </div>

          <div className="cuisine-image">
            <Carousel fade controls indicators={false}>
              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={storyImg2}
                  alt="First slide"
                />
                <Carousel.Caption>
                  {/* <p className="image-caption">
                    Our homepage will feature responsive design ensuring optimal
                    viewing across all devices with fast loading times and
                    intuitive navigation.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={storyImg1}
                  alt="Second slide"
                />
                <Carousel.Caption>
                  {/* <p className="image-caption">
                    Enjoy authentic South Indian flavors prepared with care.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>

              <Carousel.Item>
                <img
                  className="d-block w-100"
                  src={storyImg}
                  alt="Third slide"
                />
                <Carousel.Caption>
                  {/* <p className="image-caption">
                    From filter coffee to crispy dosas, we serve comfort and
                    tradition.
                  </p> */}
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
            {/* <p
              style={{ fontSize: "16px", color: "#3e3a35" }}
              className="image-caption"
            >
              Our homepage will feature responsive design ensuring optimal
              viewing across all devices with fast loading times and intuitive
              navigation.
            </p> */}
          </div>
        </div>
      </section>
    </div>
  );
}
